import type { TFunction } from 'i18next';

import type { DuelHubResponse } from '../../../services/api';
import { duelText } from './duelsText';
import { formatScore } from './duelsTheme';

type Counts = {
	requestable: number;
	openRequests: number;
	recentlyFulfilled: number;
	claimable?: number;
} | null;

const timeLeft = (t: TFunction, iso: string, now: number) => {
	const ms = Math.max(0, new Date(iso).getTime() - now);
	const hours = Math.floor(ms / 3_600_000);
	return hours >= 1
		? duelText(t, 'T_SITE_DUELS_UNIT_HOURS', [hours])
		: duelText(t, 'T_SITE_DUELS_UNIT_MINUTES', [Math.max(1, Math.ceil(ms / 60_000))]);
};

export const duelHomeCard = (
	t: TFunction,
	hub: DuelHubResponse | null,
	counts: Counts,
	now = Date.now(),
): string => {
	if (!hub) return '';

	if (counts?.requestable) {
		return duelText(t, 'T_SITE_DUELS_HOME_REWARD_UNLOCKED');
	}
	if (counts?.claimable) {
		return duelText(t, 'T_SITE_DUELS_HOME_CLAIM_REWARD');
	}
	if (counts?.openRequests) {
		return duelText(t, 'T_SITE_DUELS_HOME_UNDER_REVIEW');
	}
	if (counts?.recentlyFulfilled) {
		return duelText(t, 'T_SITE_DUELS_HOME_REWARD_SENT');
	}

	const current = hub.currentDuel;
	if (current && !current.currentPlayerFinished) {
		return duelText(t, 'T_SITE_DUELS_HOME_IN_PROGRESS');
	}
	if (current?.expiresAt) {
		return duelText(t, 'T_SITE_DUELS_HOME_RESULT_IN', [timeLeft(t, current.expiresAt, now)]);
	}
	if (!current && hub.pools.some(pool => pool.openPool)) {
		return duelText(t, 'T_SITE_DUELS_HOME_DUEL_READY');
	}

	const next = hub.rating.nextDivision;
	if (next) {
		return duelText(t, 'T_SITE_DUELS_HOME_TO_NEXT', [
			formatScore(Math.max(0, next.minRating - hub.rating.rating)),
			next.name.toUpperCase(),
		]);
	}
	return hub.rating.division.label.toUpperCase();
};
